<template>
  <div class="pa-2" id="summary">
    <!--内容-->
 <div class="row">
<v-col>
 <v-card-text class="summary">
                {{ description }}
          </v-card-text>
          </v-col>
</div>
</div>
</template>

<style>
.subHead {
  font-size: 25px;
}
.head2 {
  font-size: 20px;
  border-left: inset 6px#99CCFF;
  padding-left: 8px;
  margin-bottom: 8px;
}
.summary {
  vertical-align: middle;
  font-size: 16px;
}
</style>

<script>
export default {
  data () {
    return {
      // 説明文
      description: '有限会社コニーシステム（以下「当社」といいます。）は、お客様の個人情報保護の重要性について認識し、お客様および当社に関わる方すべての個人情報について、適切に保護することを重要な責務と考えています。個人情報の保護に関する法律（以下「個人情報保護法」といいます。）を遵守すると共に、以下のプライバシーポリシーに従い、適切な取扱い及び保護に努めます。'
    }
  }
}
</script>
